import { render, staticRenderFns } from "./GinUpdate.vue?vue&type=template&id=0998fe0e&scoped=true"
import script from "./GinUpdate.vue?vue&type=script&lang=js"
export * from "./GinUpdate.vue?vue&type=script&lang=js"
import style0 from "./GinUpdate.vue?vue&type=style&index=0&id=0998fe0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0998fe0e",
  null
  
)

export default component.exports